import {createContext} from 'react';

export const VisitContext = createContext();
export const VisitDispatchContext = createContext();
